import script from "./Race2025.vue?vue&type=script&setup=true&lang=js"
export * from "./Race2025.vue?vue&type=script&setup=true&lang=js"

import "./Race2025.vue?vue&type=style&index=0&id=08ee3c34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08ee3c34"]])

export default __exports__